export const COOKIE = {
  consentKey: 'cookieConsent',
  posthogIdentifyKey: 'isPosthogIdentify',
  options: {
    expires: 365, // cookie lifetime in days (1 year)
    sameSite: 'Lax' as const, // mitigates CSRF by restricting cross-site requests
    secure: true, // send cookie only over HTTPS
    path: '/', // make cookie available across the whole site
  },
};

export const getIsQuantaPage = (pathname: string): boolean => {
  return pathname === '/quanta';
};

export const getIsQuantaRoutes = (pathname: string): boolean => {
  return pathname.startsWith('/quanta');
};

export const isSidebarItemActive = (pathname: string, href: string): boolean => {
  return pathname === href || pathname.startsWith(href + '/');
};

export const getChevronColor = (isActive: boolean): string => {
  return isActive ? 'text-text-primary' : 'text-text-primary/50';
};
